<!-- CẤU HÌNH GIAO DIỆN  -->
<div class="line">
  <ng-container>
    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device" 
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config 
      [width]="class['line']['width']"
      [device]="device" 
      [elementChoosing]="objectChoosing"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <!-- HÌNH ĐƯỜNG KẺ  -->
    <ul nz-menu nzMode="inline" nzInlineCollapsed="false">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CẤU HÌNH ĐƯỜNG KẺ -->
      <li nz-submenu nzTitle="Kiểu đường kẻ" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="field">
          <!-- Mẫu đường kẻ -->
          <div class="items__line-pattern">
            <p class="title">Mẫu đường kẻ</p>
            <div class="items__type">
              <button nz-button class="items__type-line" (click)="chooseLine('horizontal')"
                [style.background]="config.border_title== 'horizontal' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path d="M51.5,33.5h-39a1.5,1.5,0,0,1,0-3h39a1.5,1.5,0,0,1,0,3Z" style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('vertical')"
                [style.background]="config.border_title== 'vertical' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path d="M32,53a1.5,1.5,0,0,1-1.5-1.5v-39a1.5,1.5,0,0,1,3,0v39A1.5,1.5,0,0,1,32,53Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('top-left')"
                [style.background]="config.border_title== 'top-left' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path
                    d="M12.5,53A1.5,1.5,0,0,1,11,51.5v-39A1.5,1.5,0,0,1,12.5,11h39a1.5,1.5,0,0,1,0,3H14V51.5A1.5,1.5,0,0,1,12.5,53Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('bottom-left')"
                [style.background]="config.border_title== 'bottom-left' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path d="M51.5,53h-39A1.5,1.5,0,0,1,11,51.5v-39a1.5,1.5,0,0,1,3,0V50H51.5a1.5,1.5,0,0,1,0,3Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('top-right')"
                [style.background]="config.border_title== 'top-right' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path
                    d="M51.5,53A1.5,1.5,0,0,1,50,51.5V14H12.5a1.5,1.5,0,0,1,0-3h39A1.5,1.5,0,0,1,53,12.5v39A1.5,1.5,0,0,1,51.5,53Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('bottom-right')"
                [style.background]="config.border_title== 'bottom-right' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path d="M51.5,53h-39a1.5,1.5,0,0,1,0-3H50V12.5a1.5,1.5,0,0,1,3,0v39A1.5,1.5,0,0,1,51.5,53Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>

              <button nz-button class="items__type-line" (click)="chooseLine('top-bottom-left-right')"
                [style.background]="config.border_title== 'top-bottom-left-right' ? '#f5f4f4': '#ffffff'">
                <svg width="35px" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1"
                  viewBox="0 0 64 64">
                  <title>icon line</title>
                  <path
                    d="M50.58,12.17H13.43a1.47,1.47,0,0,0-.56.11l-.2.11,0,0A1.43,1.43,0,0,0,12,13.6s0,.06,0,.09V50.4a1.43,1.43,0,0,0,.87,1.31,1.37,1.37,0,0,0,.58.12H50.58A1.41,1.41,0,0,0,52,50.42V13.58A1.41,1.41,0,0,0,50.58,12.17ZM14.84,15H49.17V49H14.84Z"
                    style="fill:#f9a44f" />
                </svg>
              </button>
            </div>
          </div>
          <!-- Kiểu viền -->
          <div class="items__line--options item mt-2">
            <p class="title">Kiểu viền</p>
            <div class="items__line--options-style">
              <button nz-button [style.background]="class.line__type['border-style'] == 'solid' ? '#e8e8e8': '#ffffff'"
                (click)=" class.line__type['border-style'] = 'solid';
                          class.point = '0';updateClass()">
                <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                    fill="#000000" />
                </svg>
              </button>
              <button nz-button [style.background]="class.line__type['border-style'] == 'dashed' ? '#e8e8e8': '#ffffff'"
                (click)="
                          class.line__type['border-style'] = 'dashed';
                          class.point = '10,10'; updateClass()">
                <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z"
                    fill="#000000" />
                </svg>
              </button>
              <button nz-button [style.background]="class.line__type['border-style'] == 'dotted' ? '#e8e8e8': '#ffffff'"
                (click)="
                          class.line__type['border-style'] = 'dotted';
                          class.point = '5,5'; updateClass()">
                <svg width="16px" height="16px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                    fill="#000000" />
                </svg>
              </button>
            </div>
          </div>
          <!-- Kích thước line ngang và dọc -->
          <div class="line-width items__line--width my-2" *ngIf="config.border_title == 'horizontal'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-top-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.line__type['border-top-width'] = $event +'px'"></nz-slider>
          </div>
          <div class="line-width items__line--width" *ngIf="config.border_title === 'vertical'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-left-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class.line__type['border-left-width'] = $event +'px'"></nz-slider>
          </div>
          <!-- top-left -->
          <div class="line-width items__line--width" *ngIf="config.border_title === 'top-left'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-left-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class.line__type['border-left-width'] = $event +'px';class.line__type['border-top-width'] = $event +'px'"></nz-slider>
          </div>
          <!-- bottom-left -->
          <div class="line-width items__line--width" *ngIf="config.border_title === 'bottom-left'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-left-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class.line__type['border-left-width'] = $event +'px';class.line__type['border-bottom-width'] = $event +'px'"></nz-slider>
          </div>
          <!-- top-right -->
          <div class="line-width items__line--width" *ngIf="config.border_title === 'top-right'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-top-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class.line__type['border-top-width'] = $event +'px';class.line__type['border-right-width'] = $event +'px'"></nz-slider>
          </div>
          <!-- bottom-right -->
          <div class="line-width items__line--width" *ngIf="config.border_title === 'bottom-right'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-bottom-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class.line__type['border-bottom-width'] = $event +'px';class.line__type['border-right-width'] = $event +'px'"></nz-slider>
          </div>
          <!-- 'top-bottom-left-right -->
          <div class="line-width items__line--width" *ngIf="config.border_title === 'top-bottom-left-right'">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-slider [nzMin]="1" [nzMax]="10" [ngModel]="class.line__type['border-top-width'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.line__type['border-top-width'] = $event +'px';
                class.line__type['border-bottom-width'] = $event +'px';
                class.line__type['border-left-width'] = $event +'px';
                class.line__type['border-right-width'] = $event +'px';
                "></nz-slider>
          </div>
          <!-- Màu viền -->
          <div class="field--device">
            <p class="title w-50" style="width:50%">{{'mau_vien' | translate}} </p>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class.line__type['border-color']"
              [style.background]="class.line__type['border-color']" (colorPickerClose)="updateClass()"
              [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
          </div>
          <div class="mt-2">
            <div class="slide-bar">
              <p class="title">{{'do_mo' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" style="min-width:40%"
                [ngModel]="class['line__type']['opacity'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['line__type']['opacity'] = $event +'%'"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100"
              [ngModel]="class['line__type']['opacity'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['line__type']['opacity'] = $event +'%'"></nz-slider>
          </div>
        </div>
      </li> 
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-rotate-config [classRotate]="class['line']" [config]="config" [device]="device"  [objectChoosing]="objectChoosing" ></app-rotate-config>
      </li>
    </ul>
  </ng-container>
</div>
